import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

const rootElement = document.getElementById('root')

// Use hydrate if the HTML was pre-rendered by react-snap (production),
// otherwise use render (development). This enables static pre-rendering
// for SEO while keeping the development experience unchanged.
if (rootElement!.hasChildNodes()) {
	ReactDOM.hydrate(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		rootElement
	)
} else {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		rootElement
	)
}

reportWebVitals()
